import React from "react";
import {TableRow} from "@mui/material";
import { defaultProps } from "recompose";
import DateHelper from "../../../../helpers/DateHelper";
import {TableCell} from "@mui/material";
import StringHelper from "../../../../helpers/StringHelper";


const BirthdateBloc = ({ birthdate, ...props}) => (
    <React.Fragment>
        {
            birthdate && <TableRow item {...props}>
                <TableCell variant="head">Date de naissance</TableCell>
                <TableCell> : </TableCell>
                <TableCell>{DateHelper.InputDateToFr(birthdate)}</TableCell>
            </TableRow>
        }
    </React.Fragment>
)


BirthdateBloc.withDefaultProps = defaultProps({
    birthdate: "",
    sm: 6,
    xs: 6,
    id: ""
})

export default BirthdateBloc;
